import WebMultimodalLearning from '../Web/PageComponents/MultimodalLearning';
import { Display } from '@/components/Display/Display';

const MultimodalLearning = (props) => {
    const { side = 'web', ...otherProps } = props;
    
    // 只支持 Web 端
    return (
        <>
            <Display show={side === 'web'}>
                <WebMultimodalLearning {...otherProps}></WebMultimodalLearning>
            </Display>
        </>
    );
};

export default MultimodalLearning;

